import withActDetail from "../withActDetail";
import ActLandForm from "./ActLandForm";
import ActLandPDFGenerator from "./ActLandPDFGenerator";

const actFormKazakhName = 'Топырақ үлгілерін іріктеу АКТІСІ'
const actFormName = 'АКТ отбора образцов почвы'
const actFormNumber = '006'
const actName = 'ActLand'

export default withActDetail(ActLandForm, ActLandPDFGenerator, actFormKazakhName, actFormName, actFormNumber, actName)